import { Button } from "@/components/ui/button";
import { CheckCircle2, AlertTriangle, Trash2, Send, Loader2 } from "lucide-react";

const FIELDS = [
  ["first_name", "First name"], ["last_name", "Last name"], ["email", "Email"], ["phone", "Phone"],
  ["company", "Company"], ["job_title", "Job title"], ["website", "Website"], ["address", "Street address"],
  ["city", "City"], ["state", "State"], ["postal_code", "ZIP"], ["notes", "Notes"],
];

const StatusPill = ({ item }) => {
  if (item.reading) return <span style={pill("#eef2ff", "#4338ca")} data-testid="pic-status-reading"><Loader2 size={13} className="animate-spin" /> Reading…</span>;
  if (item.status === "success") return <span style={pill("#dcfce7", "#15803d")} data-testid="pic-status-imported"><CheckCircle2 size={13} /> In your CRM</span>;
  if (item.status === "failed") return <span style={pill("#fee2e2", "#b91c1c")} data-testid="pic-status-failed"><AlertTriangle size={13} /> Not imported</span>;
  if (!item.success) return <span style={pill("#fef3c7", "#92400e")} data-testid="pic-status-unread"><AlertTriangle size={13} /> Couldn't read</span>;
  const c = item.confidence || 0;
  return <span style={pill(c >= 80 ? "#e0f2fe" : "#fef3c7", c >= 80 ? "#0369a1" : "#92400e")} data-testid="pic-status-confidence">{c}% confident</span>;
};

const pill = (bg, color) => ({ background: bg, color, borderRadius: 999, padding: "3px 10px", fontSize: 12, fontWeight: 600, display: "inline-flex", alignItems: "center", gap: 5 });

export const ContactReviewCard = ({ item, busy, onChange, onImport, onRemove }) => {
  const done = item.status === "success";
  const contact = item.contact || {};
  const setField = (k, v) => onChange({ contact: { ...contact, [k]: v }, ...(item.status === "failed" ? { status: undefined, error: undefined } : {}) });
  const missingKey = item.success && !contact.email && !contact.phone;

  return (
    <div data-testid={`pic-result-${item.key}`} style={{ display: "flex", gap: 16, flexWrap: "wrap", border: "1px solid #e2e8f0", borderRadius: 12, padding: 16, opacity: done ? 0.8 : 1 }}>
      <img src={item.preview} alt={item.file_name} style={{ width: 180, maxWidth: "100%", height: 120, objectFit: "contain", background: "#f8fafc", borderRadius: 8, border: "1px solid #e2e8f0" }} />
      <div style={{ flex: 1, minWidth: 260 }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 8, flexWrap: "wrap", marginBottom: 10 }}>
          <label style={{ display: "flex", alignItems: "center", gap: 8, fontWeight: 600, fontSize: 14 }}>
            {item.success && !done && (
              <input type="checkbox" checked={!!item.selected} onChange={(e) => onChange({ selected: e.target.checked })} data-testid="pic-result-select" />
            )}
            <span style={{ wordBreak: "break-all" }}>{item.file_name}</span>
          </label>
          <StatusPill item={item} />
        </div>
        {item.error && <p style={{ color: "#b91c1c", fontSize: 13, margin: "0 0 10px" }} data-testid="pic-result-error">{item.error}</p>}
        {item.success && (
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(170px, 1fr))", gap: 10 }}>
            {FIELDS.map(([k, label]) => (
              <div key={k} className="form-group" style={{ margin: 0 }}>
                <label className="form-label" style={{ fontSize: 12 }}>{label}</label>
                <input className="form-input" value={contact[k] || ""} disabled={done} data-testid={`pic-field-${k}`}
                  onChange={(e) => setField(k, e.target.value)} style={{ padding: "8px 10px", fontSize: 14 }} />
              </div>
            ))}
          </div>
        )}
        {missingKey && <p style={{ color: "#92400e", fontSize: 12, marginTop: 8 }}>Add an email or phone number to import this contact.</p>}
        <div style={{ display: "flex", justifyContent: "flex-end", gap: 8, marginTop: 12 }}>
          <Button variant="outline" size="sm" onClick={onRemove} data-testid="pic-result-remove-btn"><Trash2 size={14} style={{ marginRight: 6 }} /> Remove</Button>
          {item.success && !done && (
            <Button size="sm" onClick={onImport} disabled={busy || missingKey} data-testid="pic-result-import-btn"><Send size={14} style={{ marginRight: 6 }} /> Import</Button>
          )}
        </div>
      </div>
    </div>
  );
};
